export const defaultAttributesClient={path:"/"};